export default "__VITE_ASSET__CD6XinQf__"